module.exports = __webpack_public_path__ + "img/legendMech.21fc25a5.svg";